module.exports = __webpack_public_path__ + "static/media/p2.f5c4f0e4.png";